/**
 * User Service
 *
 * Provides functionality for working with user data.
 */

import { CrudService } from "../../core/common/crud-service";
import {
    UserSearchRequest,
    UserSearchResponseItem,
    UserGetUserRequest,
    UserGetUserResponse,
    UserCreateRequest,
    UserCreateResponse,
    UserUpdateRequest,
    UserUpdateResponse,
    UserDeleteRequest,
    UserDeleteResponse
} from "../../../model";

export class UserService extends CrudService {

    protected readonly basePath = '/api/user';

    /**
     * Search users based on criteria
     */
    async search(request: UserSearchRequest): Promise<UserSearchResponseItem[] | null> {
        return this.customPost<UserSearchRequest, UserSearchResponseItem[]>(
            'search',
            request
        );
    }

    /**
     * Get user details by ID or account
     */
    async getUser(request: UserGetUserRequest): Promise<UserGetUserResponse | null> {
        return this.customPost<UserGetUserRequest, UserGetUserResponse>(
            'getUser',
            request
        );
    }

    /**
     * Create one or more users
     */
    async create(request: UserCreateRequest): Promise<UserCreateResponse | null> {
        return this.customPost<UserCreateRequest, UserCreateResponse>(
            'create',
            request
        );
    }

    /**
     * Update one or more users
     */
    async update(request: UserUpdateRequest): Promise<UserUpdateResponse | null> {
        return this.customPost<UserUpdateRequest, UserUpdateResponse>(
            'update',
            request
        );
    }

    /**
     * Delete one or more users
     */
    async delete(request: UserDeleteRequest): Promise<UserDeleteResponse | null> {
        return this.customPost<UserDeleteRequest, UserDeleteResponse>(
            'delete',
            request
        );
    }
}

// Export a singleton instance
export const userService = new UserService();